module.exports = __webpack_public_path__ + "img/4.b0a55f27.svg";